import { useQuery } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { useProId } from '@contexts/ProIdContext';
import { GET_JOB_OFFER_TEMPLATE, GET_JOB_OFFER_TEMPLATE_UPERCUT } from '@gql/jobOfferTemplates';

export const useGetJobOfferTemplate = (jobNumber?: string) => {
    const { user, isUpercut } = useAuth();
    const { isProIdRequired } = useProId();
    const isUpercutMode = isUpercut && !isProIdRequired;

    const queryToUse = isUpercutMode ? GET_JOB_OFFER_TEMPLATE_UPERCUT : GET_JOB_OFFER_TEMPLATE;

    const { data, loading, error } = useQuery(queryToUse, {
        variables: { jobNumber },
        skip: !jobNumber || !user,
    });

    const template = isUpercutMode
        ? data?.getJobOfferTemplateUpercut
        : data?.getJobOfferTemplatePro;

    return { template, loading, error };
};
